// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/campaign.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/campaign.proto.
 */
export const file_v1_campaign: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Campaign is a campaign definition. Timestamps are RFC 3339.
 *
 * @generated from message v1.Campaign
 */
export type Campaign = Message<"v1.Campaign"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: v1.CampaignChannel channel = 3;
   */
  channel: CampaignChannel;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string starts_at = 6;
   */
  startsAt: string;

  /**
   * @generated from field: string ends_at = 7;
   */
  endsAt: string;

  /**
   * @generated from field: bool enabled = 8;
   */
  enabled: boolean;
};

/**
 * Describes the message v1.Campaign.
 * Use `create(CampaignSchema)` to create a new message.
 */
export const CampaignSchema: GenMessage<Campaign> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 0);

/**
 * CampaignProgress is the caller's progress through the Telegram steps.
 *
 * @generated from message v1.CampaignProgress
 */
export type CampaignProgress = Message<"v1.CampaignProgress"> & {
  /**
   * @generated from field: bool user_linked = 1;
   */
  userLinked: boolean;

  /**
   * @generated from field: bool group_linked = 2;
   */
  groupLinked: boolean;

  /**
   * @generated from field: bool first_message_received = 3;
   */
  firstMessageReceived: boolean;
};

/**
 * Describes the message v1.CampaignProgress.
 * Use `create(CampaignProgressSchema)` to create a new message.
 */
export const CampaignProgressSchema: GenMessage<CampaignProgress> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 1);

/**
 * @generated from message v1.GetActiveCampaignRequest
 */
export type GetActiveCampaignRequest = Message<"v1.GetActiveCampaignRequest"> & {
};

/**
 * Describes the message v1.GetActiveCampaignRequest.
 * Use `create(GetActiveCampaignRequestSchema)` to create a new message.
 */
export const GetActiveCampaignRequestSchema: GenMessage<GetActiveCampaignRequest> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 2);

/**
 * @generated from message v1.GetActiveCampaignResponse
 */
export type GetActiveCampaignResponse = Message<"v1.GetActiveCampaignResponse"> & {
  /**
   * has_campaign is false when no campaign is running or the caller is
   * ineligible; every other field is then empty.
   *
   * @generated from field: bool has_campaign = 1;
   */
  hasCampaign: boolean;

  /**
   * @generated from field: v1.Campaign campaign = 2;
   */
  campaign?: Campaign;

  /**
   * @generated from field: v1.CampaignProgress progress = 3;
   */
  progress?: CampaignProgress;

  /**
   * @generated from field: v1.CampaignRewardStatus status = 4;
   */
  status: CampaignRewardStatus;

  /**
   * projected_expired_date (YYYY-MM-DD) is the expiry the reward would set,
   * or did set once granted.
   *
   * @generated from field: string projected_expired_date = 5;
   */
  projectedExpiredDate: string;

  /**
   * show_popup is false while the caller's dismissal back-off is running or
   * the dismissal cap is reached. The header badge ignores it.
   *
   * @generated from field: bool show_popup = 6;
   */
  showPopup: boolean;
};

/**
 * Describes the message v1.GetActiveCampaignResponse.
 * Use `create(GetActiveCampaignResponseSchema)` to create a new message.
 */
export const GetActiveCampaignResponseSchema: GenMessage<GetActiveCampaignResponse> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 3);

/**
 * @generated from message v1.DismissCampaignPopupRequest
 */
export type DismissCampaignPopupRequest = Message<"v1.DismissCampaignPopupRequest"> & {
  /**
   * @generated from field: int32 campaign_id = 1;
   */
  campaignId: number;
};

/**
 * Describes the message v1.DismissCampaignPopupRequest.
 * Use `create(DismissCampaignPopupRequestSchema)` to create a new message.
 */
export const DismissCampaignPopupRequestSchema: GenMessage<DismissCampaignPopupRequest> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 4);

/**
 * @generated from message v1.DismissCampaignPopupResponse
 */
export type DismissCampaignPopupResponse = Message<"v1.DismissCampaignPopupResponse"> & {
};

/**
 * Describes the message v1.DismissCampaignPopupResponse.
 * Use `create(DismissCampaignPopupResponseSchema)` to create a new message.
 */
export const DismissCampaignPopupResponseSchema: GenMessage<DismissCampaignPopupResponse> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 5);

/**
 * AdminCampaign is a campaign with its reward counts.
 *
 * @generated from message v1.AdminCampaign
 */
export type AdminCampaign = Message<"v1.AdminCampaign"> & {
  /**
   * @generated from field: v1.Campaign campaign = 1;
   */
  campaign?: Campaign;

  /**
   * @generated from field: int64 granted_count = 2;
   */
  grantedCount: bigint;

  /**
   * @generated from field: int64 ineligible_count = 3;
   */
  ineligibleCount: bigint;

  /**
   * @generated from field: string created_by = 4;
   */
  createdBy: string;
};

/**
 * Describes the message v1.AdminCampaign.
 * Use `create(AdminCampaignSchema)` to create a new message.
 */
export const AdminCampaignSchema: GenMessage<AdminCampaign> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 6);

/**
 * @generated from message v1.ListCampaignsRequest
 */
export type ListCampaignsRequest = Message<"v1.ListCampaignsRequest"> & {
};

/**
 * Describes the message v1.ListCampaignsRequest.
 * Use `create(ListCampaignsRequestSchema)` to create a new message.
 */
export const ListCampaignsRequestSchema: GenMessage<ListCampaignsRequest> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 7);

/**
 * @generated from message v1.ListCampaignsResponse
 */
export type ListCampaignsResponse = Message<"v1.ListCampaignsResponse"> & {
  /**
   * @generated from field: repeated v1.AdminCampaign campaigns = 1;
   */
  campaigns: AdminCampaign[];
};

/**
 * Describes the message v1.ListCampaignsResponse.
 * Use `create(ListCampaignsResponseSchema)` to create a new message.
 */
export const ListCampaignsResponseSchema: GenMessage<ListCampaignsResponse> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 8);

/**
 * @generated from message v1.CreateCampaignRequest
 */
export type CreateCampaignRequest = Message<"v1.CreateCampaignRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: v1.CampaignChannel channel = 2;
   */
  channel: CampaignChannel;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string starts_at = 5;
   */
  startsAt: string;

  /**
   * @generated from field: string ends_at = 6;
   */
  endsAt: string;

  /**
   * @generated from field: bool enabled = 7;
   */
  enabled: boolean;
};

/**
 * Describes the message v1.CreateCampaignRequest.
 * Use `create(CreateCampaignRequestSchema)` to create a new message.
 */
export const CreateCampaignRequestSchema: GenMessage<CreateCampaignRequest> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 9);

/**
 * @generated from message v1.CreateCampaignResponse
 */
export type CreateCampaignResponse = Message<"v1.CreateCampaignResponse"> & {
  /**
   * @generated from field: v1.AdminCampaign campaign = 1;
   */
  campaign?: AdminCampaign;
};

/**
 * Describes the message v1.CreateCampaignResponse.
 * Use `create(CreateCampaignResponseSchema)` to create a new message.
 */
export const CreateCampaignResponseSchema: GenMessage<CreateCampaignResponse> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 10);

/**
 * UpdateCampaignRequest changes the editable fields. code and channel are
 * fixed once created, because rewards and the snapshot refer to them.
 *
 * @generated from message v1.UpdateCampaignRequest
 */
export type UpdateCampaignRequest = Message<"v1.UpdateCampaignRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string starts_at = 4;
   */
  startsAt: string;

  /**
   * @generated from field: string ends_at = 5;
   */
  endsAt: string;

  /**
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;
};

/**
 * Describes the message v1.UpdateCampaignRequest.
 * Use `create(UpdateCampaignRequestSchema)` to create a new message.
 */
export const UpdateCampaignRequestSchema: GenMessage<UpdateCampaignRequest> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 11);

/**
 * UpdateCampaignResponse carries the campaign without counts; callers that
 * show counts reload the list.
 *
 * @generated from message v1.UpdateCampaignResponse
 */
export type UpdateCampaignResponse = Message<"v1.UpdateCampaignResponse"> & {
  /**
   * @generated from field: v1.Campaign campaign = 1;
   */
  campaign?: Campaign;
};

/**
 * Describes the message v1.UpdateCampaignResponse.
 * Use `create(UpdateCampaignResponseSchema)` to create a new message.
 */
export const UpdateCampaignResponseSchema: GenMessage<UpdateCampaignResponse> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 12);

/**
 * @generated from message v1.ListCampaignRewardsRequest
 */
export type ListCampaignRewardsRequest = Message<"v1.ListCampaignRewardsRequest"> & {
  /**
   * @generated from field: int32 campaign_id = 1;
   */
  campaignId: number;
};

/**
 * Describes the message v1.ListCampaignRewardsRequest.
 * Use `create(ListCampaignRewardsRequestSchema)` to create a new message.
 */
export const ListCampaignRewardsRequestSchema: GenMessage<ListCampaignRewardsRequest> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 13);

/**
 * CampaignRewardRow is one granted reward. Dates are YYYY-MM-DD, timestamps
 * RFC 3339; notified_at is empty until the user was told.
 *
 * @generated from message v1.CampaignRewardRow
 */
export type CampaignRewardRow = Message<"v1.CampaignRewardRow"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string old_expired_date = 2;
   */
  oldExpiredDate: string;

  /**
   * @generated from field: string new_expired_date = 3;
   */
  newExpiredDate: string;

  /**
   * @generated from field: string granted_at = 4;
   */
  grantedAt: string;

  /**
   * @generated from field: string notified_at = 5;
   */
  notifiedAt: string;
};

/**
 * Describes the message v1.CampaignRewardRow.
 * Use `create(CampaignRewardRowSchema)` to create a new message.
 */
export const CampaignRewardRowSchema: GenMessage<CampaignRewardRow> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 14);

/**
 * @generated from message v1.ListCampaignRewardsResponse
 */
export type ListCampaignRewardsResponse = Message<"v1.ListCampaignRewardsResponse"> & {
  /**
   * @generated from field: repeated v1.CampaignRewardRow rewards = 1;
   */
  rewards: CampaignRewardRow[];
};

/**
 * Describes the message v1.ListCampaignRewardsResponse.
 * Use `create(ListCampaignRewardsResponseSchema)` to create a new message.
 */
export const ListCampaignRewardsResponseSchema: GenMessage<ListCampaignRewardsResponse> = /*@__PURE__*/
  messageDesc(file_v1_campaign, 15);

/**
 * CampaignChannel is the messaging channel whose adoption a campaign rewards.
 *
 * @generated from enum v1.CampaignChannel
 */
export enum CampaignChannel {
  /**
   * @generated from enum value: CAMPAIGN_CHANNEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CAMPAIGN_CHANNEL_TELEGRAM = 1;
   */
  TELEGRAM = 1,
}

/**
 * Describes the enum v1.CampaignChannel.
 */
export const CampaignChannelSchema: GenEnum<CampaignChannel> = /*@__PURE__*/
  enumDesc(file_v1_campaign, 0);

/**
 * CampaignRewardStatus is the caller's standing in the active campaign.
 *
 * @generated from enum v1.CampaignRewardStatus
 */
export enum CampaignRewardStatus {
  /**
   * @generated from enum value: CAMPAIGN_REWARD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Not all steps are done yet.
   *
   * @generated from enum value: CAMPAIGN_REWARD_STATUS_IN_PROGRESS = 1;
   */
  IN_PROGRESS = 1,

  /**
   * Every step is done; the daily batch has not granted the reward yet.
   *
   * @generated from enum value: CAMPAIGN_REWARD_STATUS_QUALIFIED = 2;
   */
  QUALIFIED = 2,

  /**
   * @generated from enum value: CAMPAIGN_REWARD_STATUS_GRANTED = 3;
   */
  GRANTED = 3,

  /**
   * Already on the channel when the campaign was created, or not eligible
   * for an account-level reason (no expiry, expired, not a regular user).
   *
   * @generated from enum value: CAMPAIGN_REWARD_STATUS_INELIGIBLE = 4;
   */
  INELIGIBLE = 4,
}

/**
 * Describes the enum v1.CampaignRewardStatus.
 */
export const CampaignRewardStatusSchema: GenEnum<CampaignRewardStatus> = /*@__PURE__*/
  enumDesc(file_v1_campaign, 1);

/**
 * CampaignService is the channel adoption campaign API available to every
 * signed-in user: whether to show the campaign popup, and dismissing it.
 *
 * @generated from service v1.CampaignService
 */
export const CampaignService: GenService<{
  /**
   * @generated from rpc v1.CampaignService.GetActiveCampaign
   */
  getActiveCampaign: {
    methodKind: "unary";
    input: typeof GetActiveCampaignRequestSchema;
    output: typeof GetActiveCampaignResponseSchema;
  },
  /**
   * @generated from rpc v1.CampaignService.DismissCampaignPopup
   */
  dismissCampaignPopup: {
    methodKind: "unary";
    input: typeof DismissCampaignPopupRequestSchema;
    output: typeof DismissCampaignPopupResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_campaign, 0);

/**
 * AdminCampaignService exposes the administrator-only campaign management.
 *
 * @generated from service v1.AdminCampaignService
 */
export const AdminCampaignService: GenService<{
  /**
   * @generated from rpc v1.AdminCampaignService.ListCampaigns
   */
  listCampaigns: {
    methodKind: "unary";
    input: typeof ListCampaignsRequestSchema;
    output: typeof ListCampaignsResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminCampaignService.CreateCampaign
   */
  createCampaign: {
    methodKind: "unary";
    input: typeof CreateCampaignRequestSchema;
    output: typeof CreateCampaignResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminCampaignService.UpdateCampaign
   */
  updateCampaign: {
    methodKind: "unary";
    input: typeof UpdateCampaignRequestSchema;
    output: typeof UpdateCampaignResponseSchema;
  },
  /**
   * @generated from rpc v1.AdminCampaignService.ListCampaignRewards
   */
  listCampaignRewards: {
    methodKind: "unary";
    input: typeof ListCampaignRewardsRequestSchema;
    output: typeof ListCampaignRewardsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_campaign, 1);

